import React ,  {useEffect, useState} from 'react';
import { Offcanvas } from 'react-bootstrap';
import {  MdArrowBackIos, MdHome, MdLogin, MdInfo, MdAddCircle , MdMap , MdTour } from "react-icons/md";
import {RiMenu5Line } from 'react-icons/ri'
import { Link, useNavigate , useLocation, Navigate } from 'react-router-dom';
import {signOut , auth} from '../../firebase';



const NavbarHome = () => {

  let navigate = useNavigate();

  const [showSlideMenu , setShowSlideMenu] = useState(false);

  const [navingActive , setNavingActive ] = useState('home');


    let currentLocation = useLocation();


  


  const logoutUser = () => {

    localStorage.removeItem("tourst_compass_user");

    signOut(auth).then(() => {

      navigate('/');
      
      }).catch((error) => {
       
      });

      window.location.reload();
}

  useEffect(() => {
  
    const determineActive = (  ) => {

      switch(currentLocation.pathname) {

        case '/home':
            setNavingActive('home');
            break;

        case '/packages':
            setNavingActive('packages');
            break;

        case '/join':
            setNavingActive('join');
            break;

        case '/about':
            setNavingActive('about');
            break;

      }

  }

  determineActive();

  } , [])

  

const user = JSON.parse(localStorage.getItem("tourst_compass_user"));

  


  return (
    <div className="d-flex-c f-sp main_navbar_area container-mid">
    


    <ul className="ul_flex">

        <li >
        
          <Link to="/" id="LinkHome" >
            <a className={`${navingActive === 'home' && 'active'}`} href=""> الصفحة الرئيسية </a>
          
          </Link>

        </li>

        <li>
        <Link to="/map" id="LinkMap" >
            <a href="">  الخريطة </a>
          
          </Link>
        </li>

        <li >
        <Link to="/packages" id="LinkPackages" >
            <a className={`${navingActive === 'packages' && 'active'}`} href="">  البكجات </a>
          
          </Link>
        </li>

        <li >
        <Link to="/join" id="LinkJoin" >
            <a className={`${navingActive === 'join' && 'active'}`} href="">  الانضمام لنا </a>
          </Link>
        </li>

        <li  >
        <Link  to="/about" id="LinkAbout" >
            <a className={`${navingActive === 'about' && 'active'}`} href="">   معلومات عنا </a>
          </Link>
        </li>

    {user ? (
      <li onClick={() => logoutUser() } >
        
         
          <a href="" style={{ fontWeight: 'bold' }} >      تسجيل الخروج  </a>
        </li>
    ) : (
      <li> 
        <Link  to="/login" id="LinkLogin" >
            <a href="">    تسجيل الدخول </a>
          </Link>
        </li>
    )}


    </ul>

    <button className='btn_menu_bar btn-white bg-white text-muted mt-1 me-2 p-1 rounded shadow' onClick={() => setShowSlideMenu(!showSlideMenu) }><RiMenu5Line size={28}/></button>

    <Offcanvas  show={showSlideMenu} onHide={()=>{setShowSlideMenu(false)}} placement='end'>
      <Offcanvas.Header className='d-flex justify-content-between'>
        <button className='bg-white focus-none border-0 p-1 ms-2 text-muted' onClick={()=>{setShowSlideMenu(false)}}><MdArrowBackIos size={24}/></button>
        <div className='fs-5 fw-bold text-muted'>  البوصلة السياحية </div>
      </Offcanvas.Header>
      <Offcanvas.Body dir='rtl'>

          <ul className="mt-4">
                  <li className='d-flex mt-2' >
                      <MdHome size={30} className='text-muted ms-1'/>
                      <Link id="RouterNavLink-4"  to="/" onClick={()=>{setShowSlideMenu(false)}}>
                          <p className="main_para text-muted">الصفحة الرئيسية</p>
                      </Link>
                  </li>
                  <li className='d-flex mt-2' >
                      <MdMap size={30} className='text-muted ms-1'/>
                      <Link id="RouterNavLink-4"  to="/map" onClick={()=>{setShowSlideMenu(false)}}>
                          <p className="main_para text-muted"> خريطتنا </p>
                      </Link>
                  </li>
                  <li className='d-flex mt-2' >
                      <MdTour size={30} className='text-muted ms-1'/>
                      <Link id="RouterNavLink-4"  to="/packages" onClick={()=>{setShowSlideMenu(false)}}>
                          <p className="main_para text-muted"> البكجات </p>
                      </Link>
                  </li>
                  <li className='d-flex mt-2' >
                      <MdAddCircle size={30} className='text-muted ms-1'/>
                      <Link id="RouterNavLink-4"  to="/join" onClick={()=>{setShowSlideMenu(false)}}>
                          <p className="main_para text-muted">الإنضمام لنا</p>
                      </Link>
                  </li>
                  <li className='d-flex mt-2' >
                      <MdLogin size={30} className='text-muted ms-1'/>
                      <Link id="RouterNavLink-4"  to="/login" onClick={()=>{setShowSlideMenu(false)}}>
                          <p className="main_para text-muted">تسجيل الدخول</p>
                      </Link>
                  </li>
                  <li className='d-flex mt-2' >
                      <MdInfo size={30} className='text-muted ms-1'/>
                      <Link id="RouterNavLink-4"  to="/about" onClick={()=>{setShowSlideMenu(false)}}>
                          <p className="main_para text-muted">معلومات عنا</p>
                      </Link>
                  </li>
              </ul>
      </Offcanvas.Body>
      <div className=' p-3' dir='rtl'>
        <div className='d-flex'>
          <p className="p-0 m-0">جميع الحقوق محفوظة @2023</p>
        </div>
      </div>
  </Offcanvas>

   <div className="d-flex-c">
   <img src="/images/icons/logo.png" className='icon_big' alt="" />
   
   {user && (
    <Link to={`/profile/${user ? user.id : '' }`} className='mr-1' >
   <img src="/images/icons/user_profile.png" className='icon_smaller' style={{ cursor: 'pointer' }} alt="" />
   </Link>
   )}


   <Link to="/cart" className='mr-1' >
   <img src="/images/icons/shopping-cart.png" className='icon_smaller' style={{ cursor: 'pointer' }} alt="" />
   </Link>
  
   </div>
  </div>
  )
}

export default NavbarHome